import { useState, useEffect } from "react";
import InputWithLabel from "./InputWithLabel";
import Button from "../buttons/button";
import SelectBox from "./SelectBox ";
import useTranslator from "../../../hooks/useTranslator";

const initialFormData = {
  batch_code: "",
  date: "",
  status: "",
};

const PastingFilter = ({ onApplyFilter, onClose, filters = {} }) => {
  const { _t } = useTranslator();
  const [filtersData, setFiltersData] = useState({
    batch_code: filters.batch_code || "",
    date:       filters.date       || "",
    status:     filters.status     || "",
  });

  useEffect(() => {
    setFiltersData({
      batch_code: filters.batch_code || "",
      date:       filters.date       || "",
      status:     filters.status     || "",
    });
  }, [filters.batch_code, filters.date, filters.status]);

  const handleChange = (e) => {
    setFiltersData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleReset = (e) => {
    e.preventDefault();
    setFiltersData(initialFormData);
    onApplyFilter(initialFormData);
    if (onClose) onClose();
  };

  const handleApply = (e) => {
    e.preventDefault();
    onApplyFilter({ ...filtersData });
    if (onClose) onClose();
  };

  return (
    <div className="dropdown_body">
      <h5 className="mb-3 border-bottom">{_t("filter_heading", "Filter")}</h5>

      <InputWithLabel
        label={_t("batch_code", "Batch Code")}
        type="text"
        name="batch_code"
        value={filtersData.batch_code}
        onChange={handleChange}
        placeholder={_t("batch_code", "Batch Code")}
      />

      <InputWithLabel
        label={_t("date", "Date")}
        type="date"
        name="date"
        value={filtersData.date}
        onChange={handleChange}
      />

      <SelectBox
        label={_t("status", "Status")}
        name="status"
        value={filtersData.status}
        onChange={handleChange}
        options={[
          { value: "",       label: _t("all", "All")              },
          { value: "mixing", label: _t("status_mixing", "Mixing") },
          { value: "packed", label: _t("status_packed", "Packed") },
        ]}
      />

      <div className="d-flex justify-content-between mt-3">
        <Button onClick={handleReset} label={_t("reset_button", "Reset")} className="reset_btn" />
        <Button className="cmn_btn" label={_t("apply_button", "Apply")} onClick={handleApply} />
      </div>
    </div>
  );
};

export default PastingFilter;
